module.exports = ".kan-mail-dialog-container {\n  font-size: 13px; }\n  .kan-mail-dialog-container ckeditor {\n    width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/mails/dialogs/mail-dialog/component.scss
// module id = ./src/modules/mails/dialogs/mail-dialog/component.scss
// module chunks = main